import { colors } from "../colors_v2.js";
import { board } from "./gameBoard_v2.js";
import { matchService } from "../matches/matchService_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { iPop } from "../ipop_v2.js";
import { P1_REMOVES, P2_REMOVES } from "../constants_v2.js";

const clearSection = async () => {
  // const actionSection = document.getElementById("actionSection");
  // actionSection.innerHTML = "";
  await renderSection();
};

const renderSection = async () => {
  const currentMatchResult = matchService.getCurrentMatch();
  if (currentMatchResult.status != 200) {
    return;
  }
  const currentMatch = currentMatchResult.currentMatch;
  const mode = currentMatch.mode;

  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAUserID = pAIdentityResponse.identity.userID;

  const isPATurn = pAUserID === currentMatch.turn ? true : false;
  document.getElementById("actionSection").innerHTML = ""; //default

  if (
    ["pending", "started"].includes(currentMatch.state) &&
    ((mode === "ownDevice" && isPATurn === true) || mode === "sameDevice")
  ) {
    const html = `
      <div id="actions">
        <div class="relative">
          <div class="actionModes" id="push">Add</div>
          <div id="addSplainer" class="i isuper">ⓘ</div>
        </div>
        <div class="relative">
          <div class="actionModes" id="rotate">Rotate</div>
          <div id="rotateSplainer" class="i isuper">ⓘ</div>
        </div>
        <div class="relative">
          <div class="actionModes" id="remove">Remove</div>
          <div id="removeSplainer" class="i isuper">ⓘ</div>
        </div>
    </div>`;
    document.getElementById("actionSection").innerHTML = html;

    const push = document.getElementById("push");
    push.style.borderColor = colors.getGameColor("hexGrid");
    const rotate = document.getElementById("rotate");
    rotate.style.borderColor = colors.getGameColor("hexGrid");
    const remove = document.getElementById("remove");
    remove.style.borderColor = colors.getGameColor("hexGrid");
    let removeButtonText = "Remove";
    if (currentMatch.turn === currentMatch.p1UserID) {
      const p1RemovesUsed = currentMatch?.p1RemovesUsed ?? 0;
      removeButtonText = `Remove <span id="numRemoves" class="courier">(${P1_REMOVES - p1RemovesUsed})</span>`;
    }
    if (currentMatch.turn === currentMatch.p2UserID) {
      const p2RemovesUsed = currentMatch?.p2RemovesUsed ?? 0;
      removeButtonText = `Remove <span id="numRemoves" class="courier">(${P2_REMOVES - p2RemovesUsed})</span>`;
    }
    remove.innerHTML = removeButtonText;
  }

  if (
    (mode === "ownDevice" && isPATurn === false) ||
    !(await matchService.pAIsPlayer())
  ) {
    const html = `
      <div id="actions"><br>
        <div id="refreshActionButton">Refresh</div>
    </div>`;
    document.getElementById("actionSection").innerHTML = html;
    const refreshActionButton = document.getElementById("refreshActionButton");
    refreshActionButton.style.borderColor = colors.getGameColor("hexGrid");
  }

  renderSelector();
};

const renderAddSplainer = (event) => {
  const text = `Add a piece on top of existing unblocked piece or in the middle`;
  iPop.render({
    text,
    event,
  });
};

const renderRotateSplainer = (event) => {
  const text = `Rotate your own piece to an unblocked direction`;
  iPop.render({
    text,
    event,
  });
};

const renderRemoveSplainer = (event) => {
  const text = `
  Remove any piece. 
  <p>The player going first can do this twice. 
  <p>The player going second can do this three times, which compensates for going second.</p>`;
  iPop.render({
    text,
    event,
  });
};

const handleMouseEnter = (event) => {
  if (!isRemoveAvailable() && event.target.id === "remove") {
    event.target.style.backgroundColor = colors.getGameColor("hexGrid");
    event.target.style.color = "gray";
    document.getElementById("numRemoves").style.backgroundColor =
      colors.getGameColor("hexGrid");
    document.getElementById("numRemoves").style.color = "gray";
    return;
  }
  event.target.style.backgroundColor = colors.getGameColor("lighterAccent");
  if (event.target.id === "remove") {
    document.getElementById("numRemoves").style.backgroundColor =
      colors.getGameColor("lighterAccent");
  }
};

const handleMouseLeave = (event) => {
  if (!isRemoveAvailable() && event.target.id === "remove") {
    event.target.style.backgroundColor = colors.getGameColor("hexGrid");
    event.target.style.color = "gray";
    return;
  }
  renderSelector();
  //event.target.style.backgroundColor = colors.getGameColor("lightAccent");
};

const isRemoveAvailable = () => {
  const currentMatchResult = matchService.getCurrentMatch();
  if (currentMatchResult.status != 200) {
    return;
  }
  const currentMatch = currentMatchResult.currentMatch;
  const turnAsPlayer = matchService.getTurn().player;
  let isRemoveAvailable = true;
  if (turnAsPlayer === "playerOne") {
    if (Object.keys(currentMatch).includes("p1RemovesUsed")) {
      if (currentMatch.p1RemovesUsed >= P1_REMOVES) {
        isRemoveAvailable = false;
      }
    }
  }
  if (turnAsPlayer === "playerTwo") {
    if (Object.keys(currentMatch).includes("p2RemovesUsed")) {
      if (currentMatch.p2RemovesUsed >= P2_REMOVES) {
        isRemoveAvailable = false;
      }
    }
  }
  return isRemoveAvailable;
};

const handRefreshActionButton = async () => {
  document.body.style.cursor = "wait";
  document.getElementById("refreshActionButton").style.cursor = "wait";
  await new Promise((resolve) => setTimeout(resolve, 50));
  try {
    await matchService.refreshCurrentMatch();
  } catch (error) {
    console.error("Refresh failed", error);
  } finally {
    document.body.style.cursor = "default";
    const refreshActionButton = document.getElementById("refreshActionButton");
    if (refreshActionButton) {
      refreshActionButton.style.cursor = "default";
    }
    board.render();
  }
};

const handlePush = async () => {
  await matchService.setAction({
    action: "push",
    player: matchService.getTurn().player,
  });
  renderSelector();
  board.renderGrid();
};

const handleRotate = async () => {
  await matchService.setAction({
    action: "rotate",
    player: matchService.getTurn().player,
  });
  renderSelector();
  board.renderGrid();
};

const handleRemove = async () => {
  if (!isRemoveAvailable()) {
    return;
  }

  await matchService.setAction({
    action: "remove",
    player: matchService.getTurn().player,
  });
  renderSelector();
  board.renderGrid();
};

const renderActionButttonAs = ({ element, state }) => {
  switch (state) {
    case "selectable":
      element.style.backgroundColor = colors.getGameColor("lightAccent");
      element.classList.remove("selected");
      element.style.cursor = "pointer";
      break;
    case "selected":
      element.style.backgroundColor = colors.getGameColor("darkAccent");
      element.classList.add("selected");
      element.style.cursor = "not-allowed";
      break;
    case "disabled":
      element.style.backgroundColor = colors.getGameColor("hexGrid");
      element.classList.remove("selected");
      element.style.cursor = "not-allowed";
      element.disabled = true;
      element.style.color = "gray";
      break;
    default:
      // dude?
      break;
  }
};

const setCanvasAppearanceFor = (action) => {
  const canvasContainer = document.getElementById("canvasContainer");
  const canvas = document.getElementById("canvas");
  switch (action) {
    case "push":
      canvasContainer.classList.remove("rotateCursor", "removeCursor");
      canvas.style.borderColor = colors.getGameColor("lightAccent");
      break;
    case "rotate":
      canvasContainer.classList.add("rotateCursor");
      canvasContainer.classList.remove("removeCursor");
      canvas.style.borderColor = "black";
      break;
    case "remove":
      canvasContainer.classList.remove("rotateCursor");
      canvasContainer.classList.add("removeCursor");
      canvas.style.borderColor = "red";
      break;
  }
};

const renderSelector = () => {
  // console.log("-----renderSelector:--------");
  // console.log("The timestamp is: " + new Date().toISOString());
  // console.trace();

  const currentMatchResult = matchService.getCurrentMatch();
  if (currentMatchResult.status != 200) {
    return;
  }

  const push = document.getElementById("push");
  const rotate = document.getElementById("rotate");
  const remove = document.getElementById("remove");
  const numRemoves = document.getElementById("numRemoves");
  const refreshActionButton = document.getElementById("refreshActionButton");

  if (document.body.contains(refreshActionButton)) {
    refreshActionButton.style.backgroundColor =
      colors.getGameColor("darkAccent");
    document.getElementById("canvasContainer").classList.remove("rotateCursor");
    document.getElementById("canvasContainer").classList.remove("removeCursor");
    return;
  }
  if (!document.body.contains(push)) {
    return;
  }

  const turnAsPlayer = matchService.getTurn().player;
  const action = matchService.getAction(turnAsPlayer);
  setCanvasAppearanceFor(action);
  switch (action) {
    case "push":
      renderActionButttonAs({ element: push, state: "selected" });
      renderActionButttonAs({ element: rotate, state: "selectable" });
      renderActionButttonAs({
        element: remove,
        state: !isRemoveAvailable() ? "disabled" : "selectable",
      });
      renderActionButttonAs({
        element: numRemoves,
        state: !isRemoveAvailable() ? "disabled" : "selectable",
      });
      break;
    case "rotate":
      renderActionButttonAs({ element: rotate, state: "selected" });
      renderActionButttonAs({ element: push, state: "selectable" });
      renderActionButttonAs({
        element: remove,
        state: !isRemoveAvailable() ? "disabled" : "selectable",
      });
      renderActionButttonAs({
        element: numRemoves,
        state: !isRemoveAvailable() ? "disabled" : "selectable",
      });
      break;
    case "remove":
      renderActionButttonAs({ element: push, state: "selectable" });
      renderActionButttonAs({ element: rotate, state: "selectable" });
      renderActionButttonAs({ element: remove, state: "selected" });
      renderActionButttonAs({ element: numRemoves, state: "selected" });
      break;
  }
};

eventHub.registerEvent("pointerover", "push", handleMouseEnter);
eventHub.registerEvent("pointerout", "push", handleMouseLeave);
eventHub.registerEvent("click", "push", handlePush);

eventHub.registerEvent("pointerover", "rotate", handleMouseEnter);
eventHub.registerEvent("pointerout", "rotate", handleMouseLeave);
eventHub.registerEvent("click", "rotate", handleRotate);

eventHub.registerEvent("pointerover", "refreshActionButton", handleMouseEnter);
eventHub.registerEvent("pointerout", "refreshActionButton", handleMouseLeave);
eventHub.registerEvent("click", "refreshActionButton", handRefreshActionButton);

eventHub.registerEvent("pointerover", "remove", handleMouseEnter);
eventHub.registerEvent("pointerout", "remove", handleMouseLeave);
eventHub.registerEvent("click", "remove", handleRemove);

eventHub.registerEvent("click", "addSplainer", renderAddSplainer);
eventHub.registerEvent("click", "rotateSplainer", renderRotateSplainer);
eventHub.registerEvent("click", "removeSplainer", renderRemoveSplainer);

export const action = {
  renderSelector,
  renderSection,
  clearSection,
};
